import React from 'react';
import { AlertDialogProps } from './AlertDialog';

export const AlertDialogContext = React.createContext<{
  alert?: (props: AlertDialogProps) => Promise<boolean>;
}>({});
